import { useEffect, useState } from 'react';
import ReactIFDO from 'react-ifdo';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from '../../store/useStore';

export const RouterIFDOTracker = () => {
  const location = useLocation();
  const [initialized, setInitialized] = useState(false);

  const userProfileStates = useAppSelector((state) => state.userProfile);

  useEffect(() => {
    if (process.env.REACT_APP_CLIENT_ENVIRONMENT !== 'local') {
      ReactIFDO.initialize(process.env.REACT_APP_IFDO_CODE); // Initializing ReactIFDO
      setInitialized(true);
    }
  }, []);

  useEffect(() => {
    if (initialized) {
      if (userProfileStates.userProfile) {
        ReactIFDO._NB_ID = userProfileStates.userProfile.id;
      } else {
        ReactIFDO._NB_ID = '';
      }

      ReactIFDO.pageView(location.pathname + location.search); // Tracking Pageviews

      ReactIFDO.strValidNotice('_NB_ID');
    }
  }, [initialized, location, userProfileStates.userProfile]);
};
